export const CONFIG = {
  configured: ["konfiguriert", "text-status-success"],
  missing: ["fehlt", "text-status-warning"],
  conflict: ["Konflikt", "text-status-danger"],
};

export const STATE = {
  ok: ["OK", "text-status-success"],
  attention: ["Prüfen", "text-status-warning"],
  missing: ["Fehlt", "text-status-warning"],
  conflict: ["Konflikt", "text-status-danger"],
};

export const ROLE = { super_admin: "Super Admin / Owner", admin_ops: "Admin Ops" };

export const SYNC = {
  ready: ["bereit, Übernahme aus", "text-fundio-muted"],
  pending: ["wird beim nächsten Start übernommen", "text-status-warning"],
  in_sync: ["übernommen", "text-status-success"],
  reused_previous: ["frühere Fassung, nicht übernommen", "text-status-danger"],
  missing: ["Secret fehlt", "text-status-warning"],
  invalid_whitespace: ["ungültig: Leerzeichen am Rand", "text-status-danger"],
  invalid_too_short: ["ungültig: unter 10 Zeichen", "text-status-danger"],
  invalid_too_long: ["ungültig: über 72 Bytes", "text-status-danger"],
  conflict: ["Konflikt, nicht übernommen", "text-status-danger"],
  not_eligible: ["kein verwaltbares Konto", "text-fundio-muted"],
};

export const PHASE = {
  onboarded: "Eingerichtet",
  inactive: "Konto deaktiviert",
  initial_password_pending: "Startpasswort aktiv, erster Login ausstehend",
  two_factor_pending: "2FA-Einrichtung ausstehend",
  secret_missing: "Secret fehlt, kein Konto angelegt",
  account_created_on_next_start: "Secret vorhanden, Konto wird beim nächsten Start angelegt",
  role_mismatch: "Rolle abweichend, keine automatische Änderung",
  owner_collision: "Kollidiert mit dem Owner-Konto",
  team_email_is_owner_config: "Team-Adresse ist als Owner konfiguriert",
  email_conflict: "Kanonischer und kompatibler E-Mail-Schlüssel widersprechen sich",
  password_conflict: "Kanonischer und kompatibler Passwort-Schlüssel widersprechen sich",
  email_missing: "Owner-E-Mail nicht konfiguriert",
  password_key_missing: "Owner-Passwort-Schlüssel fehlt (nur für Erstanlage)",
  multiple_owners: "Mehr als ein Owner-Konto",
  legacy_owner_accounts_present: "Altkonto aus Legacy-Liste vorhanden",
  config_email_is_not_owner: "Konfigurierte Adresse gehört keinem Owner-Konto",
  config_email_differs_from_owner: "Konfigurierte Adresse weicht vom bestehenden Owner ab",
  owner_created_on_next_start: "Owner wird beim nächsten Start angelegt",
  owner_missing: "Kein Owner-Konto",
};
